import React from 'react';
import { motion } from 'framer-motion';
import {
  AiOutlineAudio,
  AiOutlineDollar,
} from 'react-icons/ai';
import {
  BsTelephoneInbound,
  BsFileEarmarkMedical,
  BsDatabase,
} from 'react-icons/bs';
import { BiUserCheck } from 'react-icons/bi';

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 }
  },
};

const FeatureCard = ({ Icon, title, description }) => {
  return (
    <motion.div
      className='w-full shadow-xl flex flex-col p-6 my-4 rounded-xl hover:scale-105 duration-300'
      variants={cardVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className='w-16 h-16 mx-auto -mt-8 mb-4 bg-white flex items-center justify-center'>
        <Icon className='text-[#427cfc]' size={32} />
      </div>
      <h2 className='text-xl md:text-xl text-center mb-2'>
        {title}
      </h2>
      <p className='text-s md:text-base text-gray-600 text-center'>
        {description}
      </p>
    </motion.div>
  );
};

const Features = () => {
  const cards = [
    {
      Icon: BsTelephoneInbound,
      title: '24/7 Inbound and Outbound AI Agents',
      description: 'Pre-Assessment, Initial Appointment Scheduling, and Follow-Ups.',
    },
    {
      Icon: BsFileEarmarkMedical,
      title: 'Minimizes Paperwork and Data Entry',
      description: 'Pre-assessment forms are automatically processed, reducing manual data entry.',
    },
    {
      Icon: BiUserCheck,
      title: 'Optimizes Patient Intake',
      description: 'AI summarizes key information from pre-assessments, referrals, and test reports for quick review.',
    },
    {
      Icon: AiOutlineAudio,
      title: 'Assists Doctor During Session',
      description: 'AI records and summarizes sessions while providing real-time medical insights.',
    },
    {
      Icon: AiOutlineDollar,
      title: 'Integrated Billing and Revenue Management',
      description: 'Seamless financial processing to ensure smooth and accurate transactions.',
    },
    {
      Icon: BsDatabase,
      title: 'Seamless EHR Integration',
      description: 'Ensuring interoperability with existing healthcare systems for better efficiency.',
    },
  ];

  return (
    <div className='w-full bg-[#fff] pt-16 pb-30 md:pt-16 md:pb-40 px-6 sm:px-10'>
      <div className='max-w-[1000px] w-full mx-auto text-center flex flex-col justify-center px-4 sm:px-6'>
        <motion.h1
          className='md:text-4xl sm:text-4xl text-3xl font-medium pt-10 mb-2'
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          Transforming Healthcare with AI-Powered Solutions
        </motion.h1>
        <motion.p
          className='text-gray-600 md:text-lg text-lg pt-1 mb-20'
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          Enhancing patient care, reducing administrative burden, and optimizing practice efficiency.
        </motion.p>
      </div>

      <div className='max-w-[1240px] mx-auto grid md:grid-cols-3 gap-8'>
        {cards.map((card, index) => (
          <FeatureCard key={index} {...card} />
        ))}
      </div>
    </div>
  );
};

export default Features;
